module.exports = "#define GLSLIFY 1\nattribute vec3 position;\nattribute vec2 uv;\n\nvarying vec2 vUv;\n\nvoid main(void) {\n  vUv = uv;\n  gl_Position = vec4(position, 1.0);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./webpack/js/scene/glsl/backgroundImageV.glsl
// module id = 145
// module chunks = 0